import { createSlice } from "@reduxjs/toolkit";

const cachedUser = localStorage.getItem("mozoAdminUser");

const authSlice = createSlice({
 name: "adminAuth",
 initialState: {
  token: localStorage.getItem("mozoAdminToken") || "",
  user: cachedUser ? JSON.parse(cachedUser) : null,
 },
 reducers: {
  setCredentials(state, action) {
   state.token = action.payload.token;
   state.user = action.payload.user;
   localStorage.setItem("mozoAdminToken", action.payload.token);
   localStorage.setItem("mozoAdminUser", JSON.stringify(action.payload.user));
  },
  logout(state) {
   state.token = "";
   state.user = null;
   localStorage.removeItem("mozoAdminToken");
   localStorage.removeItem("mozoAdminUser");
  },
 },
});

export const { logout, setCredentials } = authSlice.actions;
export default authSlice.reducer;
